import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import Textbox, { TextboxProps } from 'carbon-react/lib/components/textbox';

import { WizardFormErrors } from '@futrli/ui-components/components/sidebar/wizard/types';
import { WizardRequiredFieldInfo } from '@futrli/ui-components/components/sidebar/wizard/wizard-required-field-info/wizard-required-field-info';

import styles from '../../../components/form-elements/elements.scss';

const DASHBOARD_NAME_ID = 'dashboard-name';

interface DuplicateDashboardFormProps {
  errors?: WizardFormErrors;
  name: string;
  onChangeName: TextboxProps['onChange'];
  revalidate: () => void;
}

export const DuplicateDashboardForm = ({
  errors = {},
  name,
  onChangeName,
  revalidate
}: DuplicateDashboardFormProps) => {
  const intl = useIntl();

  return (
    <Box className={styles.carbonFormFixes}>
      <WizardRequiredFieldInfo />
      <Textbox
        id={DASHBOARD_NAME_ID}
        name={DASHBOARD_NAME_ID}
        required
        value={name}
        onChange={onChangeName}
        label={intl.formatMessage({ id: 'predict.dashboards.dashboard_name', defaultMessage: 'Dashboard name' })}
        error={errors.name?.message}
        onBlur={revalidate}
      />
    </Box>
  );
};
